import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginIntoVoicemail } from '../api';
import { useSelector } from '../hook-utils';
import { actions } from '../store';
import { selectVoiceMailModal } from '../store/reducers/modals';
import { selectExtension } from '../store/reducers/queueAgents';
import { selectVmPinRequired } from '../store/reducers/voiceMail';
import Button from './Button';
import Input from './Input';
import Modal from './Modal';
import VoiceMailPage from './VoiceMailPage';
import './VoiceMailPanel.scss';

export default function VoiceMailPanel() {
  const [pin, setPin] = useState('')
  const [error, setError] = useState('')
  const extension = useSelector(selectVoiceMailModal)
  const data = useSelector(s => extension && selectExtension(s, extension))
  const pinRequired = useSelector(s => extension ? selectVmPinRequired(s, extension) : false)
  const dispatch = useDispatch()

  useEffect((() => {
    if (!extension) return
    if (data) return
    dispatch(actions.fetchExtensionsByIds([extension]))

  }), [dispatch, extension, data])

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    if (await loginIntoVoicemail(extension!, pin)) {
      dispatch(actions.setHaveVmPin(extension!))
    } else {
      setError('The PIN you have supplied is incorrect.')
    }
  }

  function handleClose() {
    setPin('')
    setError('')
    dispatch(actions.openVoiceMail(null))
    if (extension)
      dispatch(actions.removeVoicemail(extension))
  }

  if (!extension || !data) {
    return null
  }

  return <>
    <Modal className='PinDialog' isOpen={pinRequired} onRequestClose={handleClose}>
      <form onSubmit={onSubmit}>
        <p>Please provide PIN to view extension <span className='ext'>{extension.id}</span> voicemail:</p>
        <Input type='password' autoFocus required value={pin} onChange={e => setPin(e.currentTarget.value)} placeholder='PIN' autocomplete={false} />
        <Button primary>OK</Button>
        <Button onClick={handleClose} type='button'>Cancel</Button>
        <div className='error'>{error}</div>
      </form>
    </Modal>

    <Modal isOpen={!pinRequired} className='VoicemailPanel' onRequestClose={handleClose}>
      <Modal.Header>{data.name}</Modal.Header>
      <VoiceMailPage className='page' extension={extension} />
    </Modal>
  </>
}
